import { Component, ViewEncapsulation, OnInit, OnDestroy, Inject, HostListener, DOCUMENT } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { environment } from '../environments/environment';
import { filter, map, Subject, Subscription, takeUntil } from 'rxjs';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { AppState } from './app.state';
// import { AppInsightService } from './Services/AppInsights-Service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { FormsModule } from '@angular/forms';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalModule, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, IdTokenClaims, InteractionStatus, InteractionType, PopupRequest, PromptValue, RedirectRequest } from '@azure/msal-browser';
import { MsalCustom } from './Services/MsalCustom.service';
import { b2cPolicies } from './auth.config';
import { IntercomService } from './Services/IntercomService.service';
import { TokenService } from './Services/tokenservice.service';
import { GlobalLoaderComponent } from './shared/components/global-loading/global-loader.component';
import { ToastrModule } from 'ngx-toastr';
export declare enum SeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4,
}
const triplinkConfig = environment.tripLinkConfig;

declare global {
  interface Window {
    Intercom?: any;
    intercomSettings?: any;
  }
}

@Component({
  selector: 'TripLink-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // providers: [IntercomService],
  imports: [RouterOutlet, RouterModule, FormsModule, GlobalLoaderComponent, ToastrModule]
})

export class AppComponent implements OnInit, OnDestroy {
  message = 'This is a maintenance notification.';
  showBanner: boolean = false;
  private intervalId: any;
  private subscription: Subscription;
  isBrowserNotCompatable: boolean;
  loadRouting: boolean = false;
  loginDisplay = false;
  hasUser = false;
  showContent = false;
  CompanyTreeDropdownRendered = false;
  userloaded = false;
  permissionsLoaded = false;
  public userLoggedInfo = false;
  isshowTerms = false;
  versionNumber: any;
  public isMenuCollapsed = false;
  public isIframe: boolean;
  private loginFailureSubscription: Subscription;
  private loginSuccessSubscription: Subscription;
  private acquireTokenSuccessSubscription: Subscription;
  private acquireTokenFailureSubscription: Subscription;
  private appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.appInsights.instrumentationKey,
      enableAutoRouteTracking: true,
      correlationHeaderExcludedDomains: ['*.googleapis.com']
    }
  });
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private tokenService: TokenService,
    private msalCustom: MsalCustom,
    // private intercomService: IntercomService,
    public router: Router,
    public _state: AppState,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    @Inject(MsalBroadcastService) private msalBroadcastService: MsalBroadcastService,
  ) {
    this.isIframe = window !== window.parent && !window.opener;
    // this.userLoggedInfo = false;
  }
  // @HostListener('document:click', ['$event', '$event.target'])
  // onClick(event: MouseEvent, targetElement: HTMLElement): void {
  //    let cmp_dr: any = document.getElementById("cmp_dr");
  //       let isChild = cmp_dr.childNodes[0].classList;
  //      if (isChild.length>0 && (targetElement.classList[0] != 'btn' && targetElement.classList[1] !=  'dropdown-toggle' && targetElement.classList[2] != 'btn-outline-secondary')  ) {
  //           cmp_dr.childNodes[0].classList.remove('show');
  //           cmp_dr.childNodes[0].childNodes[1].classList.remove('show');
  //      }
  //      let nav_g_drpdwn: any = document.getElementById("nav_g_drpdwn");
  //       let isChild1 = nav_g_drpdwn.childNodes[0].classList;
  //      if (isChild1.length>0 && (targetElement.classList[0] != 'btn' && targetElement.classList[1] !=  'dropdown-toggle' && targetElement.classList[2] != 'btn-outline-secondary')  ) {
  //       nav_g_drpdwn.childNodes[0].classList.remove('show');
  //       nav_g_drpdwn.childNodes[0].childNodes[1].classList.remove('show');
  //      }

  // }



  ngOnInit(): void {
    this.loadIntercom();
    this.isBrowserNotCompatable = this.msalCustom.isIEBrowser();
    if (this.isBrowserNotCompatable) {
      document.getElementById('preloader').style['display'] = 'none';
    }
    this.isIframe = window !== window.parent && !window.opener;
    this.msalCustom.msalLogin();
    this._state._loginSuccess$.subscribe((res) => {
      if (res.event) {
        this.loadRouting = true;
      }
    })
    // this.tokenService.initTokenRefreshMonitor();

    // setInterval(() => {
    //   this.renewToken();
    // }, 5 * 60 * 1000);  // Check every 14 minutes
    // Initialize Intercom with anonymous visitor
    // this.intercomService.boot({
    //   hide_default_launcher: true // Hide the default launcher
    // });
  }

  private loadIntercom(): void {
    // Set Intercom settings
    window.intercomSettings = {
      app_id: 'urk3rys7',
      hide_default_launcher: true, // This hides the chat widget
      widget: {
        activator: '#intercom-banner' // Only show banner, no chat widget
      }

    };

    // Load Intercom script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://widget.intercom.io/widget/urk3rys7';

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Initialize Intercom
    script.onload = () => {
      if (window.Intercom) {
        window.Intercom('boot', {
          app_id: 'urk3rys7',
          hide_default_launcher: true, // Hide the chat widget launcher
          custom_launcher_selector: '#intercom-banner' // Use custom banner selector
        });
        // Hide the messenger completely, only show banners
        window.Intercom('update', {
          hide_default_launcher: true
        });
      }
    };
  }

  renewToken() {
    const account = this.authService.instance.getAllAccounts()[0];
    if (account) {
      const tokenRequest = {
        account: account,
        scopes: [triplinkConfig.consentScopes[0], 'offline_access'],
        forceRefresh: false // First try using cached token
      };

      this.authService.acquireTokenSilent(tokenRequest).subscribe({
        next: (response: AuthenticationResult) => {
          console.log('Token renewed successfully');
          sessionStorage.setItem('accessToken', response.accessToken);
          const expirationTime = response.expiresOn;
          sessionStorage.setItem('expirationTime', String(expirationTime));
        },
        error: (error) => {
          console.warn('Silent token acquisition failed, trying with refresh token:', error);

          // Try again with force refresh
          const refreshTokenRequest = {
            ...tokenRequest,
            forceRefresh: true
          };

          this.authService.acquireTokenSilent(refreshTokenRequest).subscribe({
            next: (response: AuthenticationResult) => {
              console.log('Token renewed successfully with refresh token');
              sessionStorage.setItem('accessToken', response.accessToken);
              const expirationTime = response.expiresOn;
              sessionStorage.setItem('expirationTime', String(expirationTime));
            },
            error: (refreshError) => {
              console.error('Refresh token acquisition failed:', refreshError);
              // Only logout if refresh token is invalid or expired
              this.authService.logoutRedirect();
            }
          });
        }
      });
    } else {
      this.authService.logoutRedirect();
    }
  }


  closeBanner(): void { this.showBanner = false; }

  ngOnDestroy() {
    this.tokenService.stopTokenRefreshMonitor();
    // this.broadcastService.getMSALSubject().next(1);
    this._destroying$.next(undefined);
    this._destroying$.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // this.broadcastService.getMSALSubject().next(1);
    if (this.loginFailureSubscription) {
      this.loginFailureSubscription.unsubscribe();
    }
    if (this.loginSuccessSubscription) {
      this.loginSuccessSubscription.unsubscribe();
    }
    if (this.acquireTokenSuccessSubscription) {
      this.acquireTokenSuccessSubscription.unsubscribe();
    }
    if (this.acquireTokenFailureSubscription) {
      this.acquireTokenFailureSubscription.unsubscribe();
    }
  }
}
